export default __webpack_public_path__ + "static/media/ShowExample.6a65b8ef.png";